import { P as r } from "./Picker-D8znovwm.js";
import { d as m } from "./define-element-Dl91r6Vu.js";
m("sp-picker", r);
//# sourceMappingURL=sp-picker--0RaPuj1.js.map
